export default "__VITE_ASSET__DVaPvmO9__"